import PatientDialog from './PatientDialog';

export default PatientDialog;
